import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var EditIcon = function EditIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "EditIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.447 2.556a1 1 0 0 0-.705.292l-.786.786 1.41 1.41.786-.786a.997.997 0 0 0-.705-1.702m-1.18 3.588-1.411-1.41-6.44 6.44-.53 1.94 1.94-.53zm.203-4.95a2.553 2.553 0 0 1 2.782 4.164L5.78 13.831a.8.8 0 0 1-.346.2l-3.452.942a.778.778 0 0 1-.955-.955l.942-3.452a.8.8 0 0 1 .2-.346l8.473-8.472c.237-.237.518-.425.828-.554",
      clipRule: "evenodd"
    })
  }));
};

export { EditIcon };
